import { api } from '@store/api'

import { TAboutMe, TToDo } from './types'

export const profileApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getInfoAbutMe: builder.query<TAboutMe, any>({
      query: (params) => ({
        url: '/users/me/',
        params,
      }),
      providesTags: ['parents', 'aboutMe', 'teacher'],
    }),
    setProfileAvatar: builder.mutation<any, { id: string; body: FormData }>({
      query: ({ id, body }) => ({
        url: `users/${id}/avatar/`,
        method: 'POST',
        body,
        formData: true,
      }),
      invalidatesTags: ['parents', 'aboutMe', 'teacher'],
    }),
    setNewPassword: builder.mutation<any, { new_password: string; old_password: string }>({
      query: (body) => ({
        url: '/users/change_password/',
        method: 'POST',
        body,
      }),
    }),

    getToDoList: builder.query<TToDo[], any>({
      query: () => ({
        url: '/todo/',
      }),
      providesTags: ['todoList'],
    }),
    createToDo: builder.mutation<any, { title: string; deadline?: string; is_completed?: boolean }>({
      query: (body) => ({
        url: '/todo/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['todoList'],
    }),
    patchToDo: builder.mutation<any, { id: string; title?: string; deadline?: string; is_completed?: boolean }>({
      query: ({ id, ...body }) => ({
        url: `/todo/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['todoList'],
    }),
    removeToDo: builder.mutation<any, string>({
      query: (id) => ({
        url: `/todo/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['todoList'],
    }),
  }),
})

export const {
  useGetInfoAbutMeQuery,
  useLazyGetInfoAbutMeQuery,
  useSetProfileAvatarMutation,
  useSetNewPasswordMutation,
  useGetToDoListQuery,
  useCreateToDoMutation,
  usePatchToDoMutation,
  useRemoveToDoMutation,
} = profileApi
